export class AppSettings {
  constructor(
    public readonly commissionPercent: number = 0,
    /** Quando true, o fluxo de caixa fica ocultado em todo o sistema. */
    public readonly cashRegisterDisabled: boolean = false,
    /** Controla a exibição do tutorial inicial da conta. */
    public readonly onboardingCompleted: boolean = false
  ) {}

  static defaults(): AppSettings {
    return new AppSettings(0, false, false);
  }

  static fromFirestore(data: Record<string, unknown> | undefined): AppSettings {
    const raw = data?.commissionPercent;
    let commissionPercent = 0;
    if (typeof raw === "number" && !Number.isNaN(raw)) {
      commissionPercent = Math.min(100, Math.max(0, raw));
    }
    const cashRegisterDisabled = data?.cashRegisterDisabled === true;
    const onboardingCompleted = data?.onboardingCompleted === true;
    return new AppSettings(commissionPercent, cashRegisterDisabled, onboardingCompleted);
  }

  toFirestore(): {
    commissionPercent: number;
    cashRegisterDisabled: boolean;
    onboardingCompleted: boolean;
  } {
    return {
      commissionPercent: this.commissionPercent,
      cashRegisterDisabled: this.cashRegisterDisabled,
      onboardingCompleted: this.onboardingCompleted,
    };
  }

  withCommissionPercent(commissionPercent: number): AppSettings {
    const v = Math.min(100, Math.max(0, commissionPercent));
    return new AppSettings(v, this.cashRegisterDisabled, this.onboardingCompleted);
  }

  withCashRegisterDisabled(disabled: boolean): AppSettings {
    return new AppSettings(this.commissionPercent, disabled, this.onboardingCompleted);
  }

  withOnboardingCompleted(completed: boolean): AppSettings {
    return new AppSettings(this.commissionPercent, this.cashRegisterDisabled, completed);
  }
}
